// Setup Guide content model. Content is data (i18n keys), not JSX — mirroring the
// retired tour's config approach so copy stays translatable and the page stays generic.

export type GuideStepType = 'info' | 'action' | 'external' | 'document';

/** Tokens resolved against the personalized context to build a CTA href in the page. */
export type CtaHrefToken = 'registrationUrl' | 'taxAuthorityUrl';

export interface GuideCta {
  labelKey: string;
  kind: 'internal' | 'external' | 'document';
  /** Static href (internal route or external URL). */
  href?: string;
  /** Resolve the href from personalized context at render time (external links). */
  hrefToken?: CtaHrefToken;
}

export interface GuideStep {
  id: string;
  icon: string;
  type: GuideStepType;
  titleKey: string;
  bodyKey: string;
  bulletKeys?: string[];
  /** Key within context.autoDerived that, when true, marks this step done automatically. */
  autoDeriveKey?: string;
  /** Show a user-tickable checkbox persisted server-side (manual acknowledgement). */
  manualCheck?: boolean;
  cta?: GuideCta;
}

/** Optional personalized block rendered inside a section, keyed by the page. */
export type GuideSectionExtra = 'cantonInfo' | 'rates' | 'vavEligibility' | 'documents' | 'deadlines';

export interface GuideSectionDef {
  id: string;
  icon: string;
  titleKey: string;
  descKey?: string;
  steps: GuideStep[];
  extra?: GuideSectionExtra;
}

export interface GuideDefinition {
  id: 'employer' | 'employee';
  sections: GuideSectionDef[];
}

/** A step is "completable" (counts toward progress) if it can be checked or auto-derived. */
export function isCompletable(step: GuideStep): boolean {
  return Boolean(step.manualCheck || step.autoDeriveKey);
}
